import { Combobox } from "@mantine/core";

import classes from "./styles.module.css";

export const ComboboxOptionSettings = Combobox.Option.extend({
  defaultProps: {
    className: classes.option,
  },
});
